module.exports = __webpack_public_path__ + "img/20250827_Laurenz-03.118a94f6.jpg";